import React from 'react'
import { FilterAutocomplete } from 'transfix-ui/components/FilterAutocomplete'
import { ISortOrderEnum } from 'types/graphqlTypes'
import { SortArrowDownIcon } from 'transfix-icons'
import { IQuoteSortingOption } from '../../hooks/useQuoteSortingOptions'

interface ISortHistoricalQuotesFilter {
  sortingOptions: IQuoteSortingOption[]
  sortBy: string
  sortDirection: ISortOrderEnum
  defaultOptionLabel: string
  onSortingOptionSelect: (id: string) => void
}

export const SortHistoricalQuotesFilter = ({
  defaultOptionLabel,
  onSortingOptionSelect,
  sortBy,
  sortDirection,
  sortingOptions,
}: ISortHistoricalQuotesFilter) => {
  const sortValue = sortingOptions?.find(
    ({ sortBy: optionSortBy, sortDirection: optionSortDirection }) =>
      sortBy === optionSortBy && sortDirection === optionSortDirection
  )

  const onSortingChange = (
    opt: string | IQuoteSortingOption | (string | IQuoteSortingOption)[] | null
  ) => {
    const option = opt as IQuoteSortingOption | null
    if (option) {
      onSortingOptionSelect(option.id)
    }
  }

  const getDropdownLabel = (opt: IQuoteSortingOption) => opt.label
  const compareDropdownIds = (optA: IQuoteSortingOption, optB: IQuoteSortingOption) =>
    optA?.id === optB?.id

  return (
    <FilterAutocomplete
      id='sorting-autocomplete'
      dataTest='sorting-autocomplete'
      label={defaultOptionLabel}
      placeholder='Sort By'
      icon={<SortArrowDownIcon size='large' />}
      options={sortingOptions}
      value={sortValue}
      setValue={onSortingChange}
      getOptionLabel={getDropdownLabel}
      getOptionSelected={compareDropdownIds}
      quickSuggest
      autoSelect={false}
    />
  )
}
